"use strict";

export default class StudentController {
  /*@ngInject*/
  constructor(
    $http,
    $scope,
    Modal,
    JSONToCSVConvertor,
    $filter,
    ColorFinder,
    $timeout,
  ) {
    this.$http = $http;
    this.$scope = $scope;
    this.Modal = Modal;
    this.JSONToCSVConvertor = JSONToCSVConvertor;
    this.$filter = $filter;
    this.ColorFinder = ColorFinder;
    this.$timeout = $timeout;
  }

  $onInit() {
    this.grab();
    this.success = false;
    this.fail = false;

    this.lessonsLoaded = false;

    this.$http.get("/api/lessons/").then((res) => {
      this.lessons = res.data;
      this.lessonsLoaded = true;
    });

    this.$http.get("/api/students/active").then((response) => {
      this.actives = response.data;
    });

    this.$http.get("/api/icons").then((response) => {
      this.icons = response.data[0] || {
        first: "",
        second: "",
        third: "",
        fourth: "",
        year12: "",
      };
    });
    this.$http.get("/api/price").then((response) => {
      this.prices = response.data.map((price) => price.value);
    });
  }

  export(data) {
    const studentData = data.map((student) => ({
      "Full Name": `${student.firstName} ${student.lastName}`,
      "First Name": student.firstName || " ",
      "Last Name": student.lastName || " ",
      "Client Full Name": `${student.clientFirstName} ${student.clientLastName}`,
      "Client First Name": student.clientFirstName || " ",
      "Client Last Name": student.clientLastName || " ",
      Email: student.clientEmail || " ",
      Phone: student.clientPh || " ",
      Grade: student.grade || " ",
      Subjects: student.subjects || " ",
      "CRM ID": student.crmID || " ",
      "Is Active": student.isActive || "false",
      "Is Tertiary": student.isTertiary || "false",
    }));
    this.JSONToCSVConvertor(studentData, "Student Export", true);
  }

  grab() {
    this.$http.get("/api/students").then((response) => {
      this.students = response.data;
    });
  }

  mergeNames(student) {
    var name = `${student.firstName} ${student.lastName}`;
    if (student.clientFirstName || student.clientLastName) {
      name += ` - ${student.clientFirstName} ${student.clientLastName}`;
    }
    return name;
  }

  createStudent(newStudent) {
    this.$http
      .post("/api/students", newStudent)
      .then(() => {
        this.grab();
        this.error = "";
        this.$scope.newStudent = {};
        this.$scope.notes = false;
      })
      .catch((res) => {
        this.error = JSON.stringify(res.data, null, "\t");
      });
  }

  addStudent(newStudent) {
    if (newStudent) {
      newStudent.fullName = this.mergeNames(newStudent);
      /* Check the Student CRM ID format before inserting into the DB */
      if (newStudent.crmID !== undefined) {
        var regex = /\d+-[1-9]/;
        if (
          regex.test(newStudent.crmID) &&
          newStudent.crmID.split("-")[0].length === 5
        ) {
          this.$http
            .get("/api/students/crm-id", { params: { id: newStudent.crmID } })
            .then((res) => {
              if (res.data === "") {
                this.createStudent(newStudent);
              } else {
                this.error = "The CRM ID already exists. Try another one";
              }
            });
        } else {
          this.error = "Wrong format CRM ID";
        }
      } else {
        this.createStudent(newStudent);
      }
    }
  }

  patchStudent(student, callback) {
    if (student) {
      student.fullName = this.mergeNames(student);
      /* Check the Student CRM ID format before updating the DB */
      if (student.crmID !== "") {
        var regex = /\d+-[1-9]/;
        if (
          regex.test(student.crmID) &&
          student.crmID.split("-")[0].length === 5
        ) {
          this.$http
            .get("/api/students/crm-id", { params: { id: student.crmID } })
            .then((res) => {
              if (res.data === "" || res.data._id === student._id) {
                this.$http
                  .put(`/api/students/${student._id}`, student)
                  .then(() => {
                    this.grab();
                    this.error = "";
                    callback();
                  })
                  .catch((err) => {
                    this.error = JSON.stringify(err.data, null, "\t");
                  });
              } else {
                this.error = "The CRM ID already exists. Try another one";
              }
            });
        } else {
          this.error = "Wrong format CRM ID";
        }
      } else {
        this.error = "Wrong format CRM ID";
      }
    }
  }

  openModal(student) {
    this.Modal.editStudent(student);
  }

  markInactiveStudents(students) {
    console.log("Marking inactive students...");
    const threeMonthsAgo = new Date();
    threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 3);
    const ids = [];
    students.forEach((student) => {
      const stats = this.calculateStudentStats(student);

      if (
        student.isActive &&
        stats.lastSession &&
        stats.lastSession < threeMonthsAgo
      ) {
        ids.push(student._id);
      }
    });

    if (ids.length == 0) {
      alert("No students to mark as inactive.");
      return;
    }

    this.$http.post("/api/students/mark-inactive", { ids }).then(
      (response) => {
        alert(`${response.data.nModified} students marked as inactive.`);
        this.grab();
      },
      (error) => {
        console.error("Error marking inactive students:", error);
        alert("An error occurred while marking inactive students.");
      },
    );
  }

  calculateStudentStats(student) {
    const msDay = 1000 * 60 * 60 * 24;
    const today = new Date();

    let totalSessions = 0;
    let lastSession = null;

    const studentLessons = this.lessons.filter(
      (lesson) => lesson.clientUID === student._id,
    );

    studentLessons.forEach((lesson) => {
      const lessonStart = this.$filter("reparseDate")(lesson.date);

      if (lessonStart > today) {
        return;
      }

      let maxPossible =
        Math.floor(
          (today.getTime() - lessonStart.getTime()) / msDay / lesson.frequency,
        ) + 1;

      if (lesson.instances !== 0 && lesson.instances < maxPossible) {
        maxPossible = lesson.instances;
      }

      for (let i = 0; i < maxPossible; i++) {
        // Skip hidden/cancelled occurrence
        if (
          lesson.overwriteVisibility &&
          lesson.overwriteVisibility[i] === true
        ) {
          continue;
        }

        const colour = this.ColorFinder(lesson, i);

        // Ignore cancelled sessions (red)
        if (colour.includes("red")) {
          continue;
        }

        const occurrenceDate = new Date(
          lessonStart.getTime() + i * lesson.frequency * msDay,
        );

        if (occurrenceDate > today) {
          continue;
        }

        totalSessions++;

        if (!lastSession || occurrenceDate > lastSession) {
          lastSession = occurrenceDate;
        }
      }
    });

    return {
      totalSessions,
      lastSession,
    };
  }
}



// WEBPACK FOOTER //
// ./client/app/admin/student/student.controller.js